import React, { Component, createContext, useContext } from 'react'
import ReactDOM, { render } from 'react-dom';
import { useState, useEffect, useMemo, useRef } from 'react';
import { useCookies } from "react-cookie";
import RangeSlider from 'react-bootstrap-range-slider';
import { Table, SearchBox } from './TableMaster';
import { GlobalFilter, DefaultFilterForColumn, SelectColumnFilter, DateRangeColumnFilter, dateBetweenFilterFn, FiltersApply } from "./CustomFilter";
import { intialfiltervalues, intialtwofiltervalues } from './FilterInitialstate';
import LoadingSpinner from '../Loading-Component/Loading';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import StaffSearch from '../StaffSearch-Component/Staff-Search';
import DropdownMenu from '../../../node_modules/react-bootstrap/esm/DropdownMenu';
import { apiUrl } from '../../config.js';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { Modal, Container, Row, Col, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsFillPencilFill, BsTrashFill, BsCheck2Square, BsXLg, BsFillEyeFill, BsExclamationTriangleFill, BsTrash3Fill } from "react-icons/bs";
import "./TableStyles.scss";
import { useAccessGroup } from '../../AccessGroupContext.js';
import { useFeatureFlag } from '../../FeatureFlagContext.js';



function Screeningtable() {
    const [PrescreenmodalShow, setPrescreenmodalShow] = useState(false);
    const [ScreeningavailablitymodalShow, setScreeningavailablitymodalShow] = useState(false);
    const [Bulkupdatepopupmodal, setBulkupdatepopupmodal] = useState(false);
    const [staffdata, setstaffdata] = useState([]);
    const [ErrorMessage, setErrorMessage] = useState(null);
    const [isLoadingcompleted, setisisLoadingcompleted] = useState(false);
    const [PopupPreScreeningdata, setPopupPreScreeningdata] = useState([]);
    const [PopupScreeningAvailbalitydata, setPopupScreeningAvailbalitydata] = useState([]);
    const [FilterNames, setFilterNames] = useState([]);
    const [changepswdmodal, setchangepswdmodal] = useState(false);
    const [reset, setReset] = useState(false);
    const [screeningddls, setScreeningddls] = useState([]);
    const [screeningData, setScreeningData] = useState([]);
    const [isddlloaded, setisddlloaded] = useState(false);
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [savedfilterdata, setSavedfilterdata] = useState({});
    const [ListofCompanies, setListofCompanies] = useState([]);
    const [filtersTorender, setfiltersTorender] = useState(intialfiltervalues);
    const [saveFilternames, setsaveFilternames] = useState({});
    const [loading, setLoading] = useState(true);
    const [companyNameslist, setCompanyNameslist] = useState("");
    const [globalFilterValue, setglobalFilterValue] = useState('');
    const [exportaccess, setexposeaccess] = useState(false);
    const [showModalstaffsearch, setshowModalstaffsearch] = useState(false);
    const [selectedfiltername, setSelectedfiltername] = useState({ id: '', name: '' });
    const [isEditing, setIsEditing] = useState(false);
    const [editedName, setEditedName] = useState('');
    const [originalName, setOriginalName] = useState('');
    const [Forfiltertags, setForfiltertags] = useState({
        Allfilters: intialfiltervalues,
        checkboxfilters: intialtwofiltervalues
    });
    const [Allfiltersvals, setAllfiltersvals] = useState(intialfiltervalues);
    const [checkboxfiltersvals, setcheckboxfiltersvals] = useState(intialtwofiltervalues);
    const { accessGroups, setAccessGroups } = useAccessGroup();
    const { featureFlags, setFeatureFlags } = useFeatureFlag();
    const [cookies, setCookie] = useCookies(["jwt", "coid", "loggedInTime", "vettingFilters"]);
    const jwt = cookies['jwt'];
    const coid = cookies['coid'];
    const UserId = cookies['userid'];
    const Uname = cookies['username'];
    const v2routback = cookies['vettingFilters'];
    const formatDate = (date) => {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    };
    useEffect(() => {



        async function fetchData() {
            setLoading(true);
            setisddlloaded(false);
            await fetch(`${apiUrl}/screeningsummary/GetScreeningwithcontext`, {
                headers: { "Authorization": `bearer ${jwt}` }
            })
                .then(res => res.json())
                .then(screeningData => {
                    setScreeningData(screeningData.data);
                    const val = Object.keys(screeningData).map(function (v1) {
                        // setvalues(screeningData[v1]);


                    });
                })
                .catch(error => console.log(error))
                .finally(() => { setLoading(false) });

        }
        async function fetchDDL() {

            await fetch(`${apiUrl}/screeningsummary/LoadAllDDL`, {
                headers: { "Authorization": `bearer ${jwt}` }
            })
                .then(resp => resp.json())
                .then(screeningddls => {
                    if (screeningddls.message != null) {
                        window.alert(screeningddls.message);
                        setLoading(false);
                    }
                    else {
                        fetchaccessvaribales();

                        fetchDDLforFilters();
                        if (coid === '40') {
                            fetchCompaniesList();
                        }
                        setScreeningddls(screeningddls.screeningDdls);

                        setisddlloaded(true);
                        setLoading(false);
                    }

                });


            async function fetchCompaniesList() {
                await fetch(`${apiUrl}/screeningsummary/GetListofCompanies`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `bearer ${jwt}`,
                    }
                }).then(res => res.json())
                    .then(ListofCompanies => {
                        if (ListofCompanies.message != null) {
                            window.alert(ListofCompanies.message);
                        }
                        else {
                            setListofCompanies(ListofCompanies.data);
                        }


                    })
            }
            async function fetchaccessvaribales() {
                await fetch(`${apiUrl}/screeningsummary/Getaccessvaribales`, {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `bearer ${jwt}`,
                    }
                }).then(res => res.json())
                    .then(exposeaccess => {

                        if (exposeaccess.message != null) {
                            window.alert(exposeaccess.message);
                        }
                        else {
                            setexposeaccess(exposeaccess.data);
                        }

                    })
            }
        }

        setfiltersTorender(intialfiltervalues);
        fetchDDL();
        const loggedInTime = formatDate(new Date());
        setCookie('loggedInTime', loggedInTime, { path: '/' });
        document.title = "C247 + ScreeningSummary"
    }, []);
    const fetchDDLforFilters = async () => {

        await fetch(`${apiUrl}/screeningsummary/GetAllFilternames`, {
            headers: { "Authorization": `bearer ${jwt}` }
        }).then(resp => resp.json()).then(response => {

            if (response.message != null) {
                window.alert(response.message);
            }
            else {
                setFilterNames(response.data);
            }
            
        });


    }
    useEffect(() => {
        fetchDDLforFilters();
        Updatefiltertags(filtersTorender);

    }, [filtersTorender])

    useEffect(() => {
      
//            localStorage.getItem('vettingFilters');
        if (v2routback) {
            try {

                setfiltersTorender(v2routback);
                handleFilterSubmit(v2routback);
            } catch (err) {
                console.warn('Could not parse saved filters', err);
            }

            //localStorage.removeItem('vettingFilters');
            document.cookie = 'vettingFilters=; Max-Age=0; path=/;'
        }
    }, []);


    function getCookieValue(cookieName) {
        let name = cookieName + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function listenSpecificCookieChange(cookieNames, callback, interval = 1000) {
        let lastCookies = {};
        cookieNames.forEach(name => {
            lastCookies[name] = getCookieValue(name);
        });

        setInterval(() => {
            let changed = false;
            let changes = {};

            cookieNames.forEach(name => {
                let currentValue = getCookieValue(name);
                if (lastCookies[name] !== currentValue) {
                    changes[name] = {
                        oldValue: lastCookies[name],
                        newValue: currentValue
                    };
                    lastCookies[name] = currentValue;
                    changed = true;
                }
            });

            if (changed) {
                callback(changes);
            }
        }, interval);
    }

    // Initiating cookie change listening for 'userid','username' and 'coid'
    listenSpecificCookieChange(['userid', 'username', 'coid'], (changes) => {
        for (const [name, change] of Object.entries(changes)) {
            console.log(`Cookie "${name}" changed from "${change.oldValue}" to "${change.newValue}"`);
        }
    }, 1000);


    const MydModalWithGrid = ({ show, onHide, data }) => {

        if (isLoadingcompleted) {
            return (
                <Modal show={show} onHide={onHide} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Pre Screening Items</Modal.Title>
                    </Modal.Header>

                    <Modal.Body >
                        <div className="model-table-container">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            <div className="table-cell">Name of document</div>
                                        </th>
                                        <th >
                                            <div className="table-cell">Date received</div>
                                        </th>
                                        <th >
                                            <div className="table-cell" >Status</div>
                                        </th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index}>
                                            <td >
                                                <div className="table-cell">{item.title}</div>
                                            </td>
                                            <td >
                                                <div className="table-cell" title={item.details} >{item.details}</div>
                                            </td>
                                            <td >
                                                <div className="table-cell svg-icon" title={"click to see reference docs"} style={{ color: item.colour }} ><a

                                                    onClick={() => {
                                                        var x = window.open();
                                                        x.document.open();
                                                        if (item.link.split(':')[0] == 'data') {

                                                            x.document.write(item.link);
                                                        }
                                                        else {
                                                            x.document.write(item.link);
                                                        }
                                                        x.document.close();
                                                    }}

                                                    style={{ color: item.colour }} ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-info-circle" viewBox="0 0 16 16">
                                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                                    </svg></a></div>
                                            </td>

                                        </tr>

                                    ))}
                                </tbody>
                            </table>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onHide}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>


            )
        }
    }

    const SliderWithInputFormControl = ({ handleslider, reset }) => {

        const [value, setValue] = React.useState(0);
        useEffect(() => {
            if (filtersTorender.Distance !== undefined && JSON.stringify(filtersTorender.Distance) !== JSON.stringify(intialfiltervalues.Distance)) {
                setValue(parseInt(filtersTorender.Distance, 10));
            }
            else if (reset) {
                setValue(0);
            } else {
                setValue(0);
            }

        }, [filtersTorender, reset]);



        const handleonChange = (e) => {
            setValue(e.target.value);
            handleslider(e.target.value);

        }



        return (
            <Form>


                <Form.Group>
                    <div className="range-slider">
                        <label className="mt-3">Range:</label>
                        <RangeSlider
                            value={value}
                            onChange={e => { handleonChange(e) }}
                            max={50}
                        />
                    </div>
                    <div className="range-input-value">
                        <Form.Control value={`${value} Miles`} className="custom-cursor" readOnly />
                    </div>
                </Form.Group>
            </Form>
        );

    };

    const HandlePrescreeningPopups = async (id) => {
        setisisLoadingcompleted(false);
        try {
            const response = await fetch(`${apiUrl}/screeningsummary/GetPrescreeningcontent/${id}`, {
                headers: { "Authorization": `bearer ${jwt}` }
            }).then(resp => resp.json())
                .then(PopupPreScreeningdata => {

                    setPopupPreScreeningdata(PopupPreScreeningdata.data);
                    setisisLoadingcompleted(true);
                    if (PopupPreScreeningdata.message != null) {
                        window.alert(PopupPreScreeningdata.message);
                        setisisLoadingcompleted(true);
                    }
                    else {
                        setPopupPreScreeningdata(PopupPreScreeningdata.data);
                        setisisLoadingcompleted(true);
                    }


                });



        } catch (error) {
            console.error(error);
        }
    };
    const PreScreeningavailablityWithGrid = ({ show, onHide, data }) => {

        if (isLoadingcompleted) {
            return (

                <Modal show={show} onHide={onHide} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Pre Screening Availablity</Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                        <table>
                            <thead>
                                <tr>
                                    <th className="table-cell">Date</th>
                                    <th className="table-cell text-center">Allocation Name</th>
                                    <th className="table-cell">Start Time</th>
                                    <th className="table-cell">Finish Time</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, index) => (
                                    <tr key={index}>
                                        <td className="table-cell" >{new Date(item.dt).toLocaleDateString('en-GB', {
                                            day: '2-digit',
                                            month: '2-digit',
                                            year: 'numeric'
                                        })}</td>

                                        <td className="table-cell" >{item.allocationname}</td>

                                        <td className="table-cell" >{item.starttime}</td>

                                        <td className="table-cell" >{item.finishtime}</td>


                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onHide}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>


            )
        }
    }

    const Passwordconfirmationpswd = ({ show, onHide }) => {

        const [username, setUsername] = useState(Uname);
        const [password, setPassword] = useState('');




        const handlePasswordChange = (e) => {
            setPassword(e.target.value);

        }

        const handedlpswdchanges = async () => {
            if (password === '' || password === undefined) {

                window.alert('Please enter the passowrd to change the company');
            }

            else {
                try {
                    setLoading(true);
                    const response = await fetch(`${apiUrl}/Login/AuthenticateAsync`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            'username': `superadmin@${companyNameslist}`,
                            'password': password
                        })
                    });

                    if (response.ok) {
                        const logindetails = JSON.parse(await response.text())
                        setCookie("jwt", logindetails.jwt, { path: "/", secure: true, httpOnly: false });
                        setCookie("userid", logindetails.userid, { path: "/" });
                        // setCookie("coid", logindetails.coid, { path: "/" });
                        setCookie("username", logindetails.username, { path: "/" });
                        //navigate('/screeningsummary');
                    } else {
                        setCookie("jwt", "", { path: "/" });
                        setCookie("userid", "", { path: " / " });
                        // setCookie("coid", "", { path: "/" });
                        setCookie("username", "", { path: "/" });
                        alert('Invalid username or password');
                        setLoading(false);
                    }


                    if (response.status == 200 || response.statusText == "OK") {

                        window.location.reload();
                        setLoading(false);
                    }

                }
                catch (error) {
                    console.error(error);
                    setLoading(false);
                }
            }
        }

        return (
            <>
                <Modal show={show} onHide={onHide}>
                    <Modal.Header closeButton>
                        <Modal.Title>Company Change Confirmation Modal</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Form.Group controlId="formUsername">
                                <Form.Label>Username</Form.Label>
                                <Form.Control type="text" value={username} readOnly />
                            </Form.Group>

                            <Form.Group controlId="formPassword">
                                <Form.Label>Password</Form.Label>
                                <Form.Control type="password" value={password} onChange={handlePasswordChange} />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={onHide}>
                            Close
                        </Button>
                        <Button variant="secondary" onClick={handedlpswdchanges}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    const HandleScreeningAvailablityPopups = async (id) => {
        setisisLoadingcompleted(false);
        try {
            const response = await fetch(`${apiUrl}/screeningsummary/GetScreeningAvailability/${id}`, {
                headers: { "Authorization": `bearer ${jwt}` }
            }).then(resp => resp.json())
                .then(PopupScreeningAvailbalitydata => {
                    if (PopupScreeningAvailbalitydata.message != null) {
                        window.alert(PopupScreeningAvailbalitydata.message);
                        setisisLoadingcompleted(true);
                    }
                    else {
                        setPopupScreeningAvailbalitydata(PopupScreeningAvailbalitydata.data);
                        setisisLoadingcompleted(true);
                    }

                });



        } catch (error) {
            console.error(error);
        }
    };
    const EditableCell = ({
        value: initialValue,
        row: { index, original },
        column: { id, Header },
        updateMyData,
    }) => {

        const [DDLval, setDDLval] = React.useState(initialValue == null ? "Select" : initialValue)

        const onChange = (event) => {
            if (id == "referer") {
                setDDLval(event.target.value);

            }
            else {
                setDDLval(event);
            }
        }


        const onBlur = (e, i) => {
            if (id == "referer") {
                e = e.target.value;
                const selectedID = null;
                updateMyData(index, id, e, selectedID, original.staffID, Header)
            }
            else {
                const selectedItem = i.target.closest('.dropdown-item');
                const selectedID = selectedItem.getAttribute('value');
                updateMyData(index, id, e, selectedID, original.staffID, Header)
            }

        }
        React.useEffect(() => {
            if (initialValue == null) {
                initialValue = "Select";
            }
            else {
                setDDLval(initialValue)
            }

        }, [initialValue])

        const ddls = Object.keys(screeningddls);

        const tooltip = (
            <Tooltip id={`table-tooltip`}>
                {DDLval}
            </Tooltip>
        );

        if (id == "profileName") {
            const values = screeningddls[ddls[0]];
            return (

                <OverlayTrigger placement="top" overlay={tooltip} >
                    <Dropdown onSelect={onChange, onBlur} >
                        <Dropdown.Toggle variant="light" id="dropdown-split-basic">
                            <div className="fixed-width">{DDLval}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>

                            {
                                values && values.map((options) =>
                                    <Dropdown.Item eventKey={options.profilename} value={options.id} >{options.profilename}</Dropdown.Item>

                                )
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </OverlayTrigger>
            )
        }
        if (id == "assignedToName") {

            const values = screeningddls[ddls[1]];
            return (
            <OverlayTrigger placement = "top" overlay = { tooltip } >
                <Dropdown onSelect={onChange, onBlur} >
                    <Dropdown.Toggle variant="light" id="dropdown-split-basic">
                        <div className="fixed-width">{DDLval}</div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                    <Dropdown.Item eventKey="Select" value="0">
                        Select
                    </Dropdown.Item>

                        {
                                values && values.map((options) =>
                                <Dropdown.Item value={options.id} eventKey={options.screeningofficer}>{options.screeningofficer}</Dropdown.Item>

                                )
                            }
                        </Dropdown.Menu>
                    </Dropdown>
                </OverlayTrigger>
            )
        }
        if (id == "statusDescription") {

            const values = screeningddls[ddls[2]];

            return (
                <>
                    <OverlayTrigger placement="top" overlay={tooltip}>
                        <Dropdown onSelect={onChange, onBlur} >
                            <Dropdown.Toggle variant="light" id="dropdown-split-basic">
                                <div className="fixed-width">{DDLval}</div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>

                                {
                                    values &&  values.map((options) =>
                                        <Dropdown.Item value={options.id} eventKey={options.statusname}>{options.statusname}</Dropdown.Item>

                                    )
                                }
                            </Dropdown.Menu>
                        </Dropdown >

                    </OverlayTrigger>
                </>
            )
        }
        if (id == "areaManagerName") {

            const values = screeningddls[ddls[3]];
            return (
                <OverlayTrigger placement="top" overlay={tooltip}>
                    <Dropdown onSelect={onChange, onBlur} >
                        <Dropdown.Toggle variant="light" id="dropdown-split-basic">
                            <div className="fixed-width">{DDLval}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>

                            {
                                values && values.map((options) =>
                                    <Dropdown.Item value={options.id} eventKey={options.areamanger}>{options.areamanger}</Dropdown.Item>

                                )
                            }
                        </Dropdown.Menu>
                    </Dropdown >
                </OverlayTrigger>
            )
        }
        if (id == "dep1") {

            const values = screeningddls[ddls[4]];
            return (
                <OverlayTrigger placement="top" overlay={tooltip}>
                    <Dropdown onSelect={onChange, onBlur} >
                        <Dropdown.Toggle variant="light" id="dropdown-split-basic">
                            <div className="fixed-width">{DDLval}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>

                            {
                                values && values.map((options) =>
                                    <Dropdown.Item eventKey={options.workbase}>{options.workbase}</Dropdown.Item>

                                )
                            }
                        </Dropdown.Menu>
                    </Dropdown >
                </OverlayTrigger>
            )
        }
        if (id == "dep2") {

            const values = screeningddls[ddls[5]];
            return (
                <OverlayTrigger placement="top" overlay={tooltip}>
                    <Dropdown onSelect={onChange, onBlur} >
                        <Dropdown.Toggle variant="light" id="dropdown-split-basic">
                            <div className="fixed-width">{DDLval}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>

                            {
                                values && values.map((options) =>
                                    <Dropdown.Item eventKey={options.department2}>{options.department2}</Dropdown.Item>

                                )
                            }
                        </Dropdown.Menu>
                    </Dropdown >
                </OverlayTrigger>
            )
        }
        if (id == "dep3") {

            const values = screeningddls[ddls[6]];
            return (
                <OverlayTrigger placement="top" overlay={tooltip}>
                    <Dropdown onSelect={onChange, onBlur} >
                        <Dropdown.Toggle variant="light" id="dropdown-split-basic">
                            <div className="fixed-width">{DDLval}</div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>

                            {
                                values && values.map((options) =>
                                    <Dropdown.Item eventKey={options.department3}>{options.department3}</Dropdown.Item>

                                )
                            }
                        </Dropdown.Menu>
                    </Dropdown >
                </OverlayTrigger>
            )
        }
        if (id == "referer") {

            if (DDLval === "Select") {
                return <input onChange={onChange} placeholder={"Enter Referrer"} className="rounded referrer-input" onBlur={onBlur} />
            }
            return <input value={DDLval} onChange={onChange} placeholder={"Enter Referrer"} className="rounded referrer-input" onBlur={onBlur} />


        }
    }
    const renderTooltip = (street, houseno, postcode, setShowTooltip) => (
        <Tooltip className="custom-tooltip" >
            House No: {houseno}
            <br />
            Street: {street}
            <br />
            Post Code : {postcode}
            <br />

        </Tooltip>
    );
    const LocationCell = ({ cell, row }) => {
        const [showTooltip, setShowTooltip] = useState(false);
        return (
            <OverlayTrigger
                trigger="click"

                placement="top"
                overlay={renderTooltip(row.original.street_1, row.original.houseNo, row.original.postCode, setShowTooltip)}
                rootClose
            >
                <span style={{ cursor: "pointer" }}>{cell.value}</span>
            </OverlayTrigger>
        );
    };
    const filterColumns = (columns) => {
        return columns.filter((column) => {
            if (column.accessor === "companyname") {
                return column.isVisible = (cookies.userid == 1);
            }
            return true;
        });
    };
    const columns = React.useMemo(

        () => [
            {
                Header: "Vetting Profile",
                accessor: "Edit",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ row: { original } }) => {
                    const handleClick = () => {
                        setCookie('vettingFilters', JSON.stringify(filtersTorender), { path: '/' })
                        //localStorage.setItem('vettingFilters', JSON.stringify(filtersTorender));
                    };
                    return (
                        <a
                            href={`${apiUrl}/v1/vetting_management.aspx?id=${original.staffID}`}
                            rel="nofollow"
                            onClick={handleClick}
                            style={{ color: 'white' }}
                        >
                            <BsFillEyeFill />
                        </a>
                    );
                },
            },
            {
                Header: "Company",
                accessor: "companyname",
                Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: (cookies.userid != 1),
                isVisible: (cookies.userid == 1),


            },
            {
                Header: "ID",
                accessor: "staffID",
                defaultCanFilter: false,
                filterable: false,
                hidden: true,
            },
            {
                Header: "Last Name",
                accessor: "lastname",
                filter: 'equals',
                filterable: false,
                hidden: true
            },
            {
                Header: "First Name",
                accessor: "firstname",
                filter: 'equals',
                filterable: false,
                hidden: true
            },
            {
                Header: "Middle Name",
                accessor: "middlename",
                filter: 'equals',
                filterable: false,
                hidden: false
            },
            {
                Header: "Assigned To",
                accessor: "assignedToName",
                Filter: SelectColumnFilter,
                filter: 'equals',
                defaultCanFilter: false,
                filterable: true,
                Cell: EditableCell,
            },
            {
                Header: "Profile",
                accessor: "profileName",
                Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: true,
                Cell: EditableCell,
                hidden: true


            },
            {
                Header: "Referrer",
                accessor: "referer",
                //Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                Cell: EditableCell,
                hidden: false

            },
            {
                Header: "Engagement Method",
                accessor: "engagementMethodDescription",
                Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: true,
                hidden: false
            },
            {
                Header: "Location",
                accessor: "post_Town",
                Filter: DefaultFilterForColumn,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ cell, row }) => <LocationCell cell={cell} row={row} />,
            },
            {
                Header: "Status",
                accessor: "statusDescription",
                Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: true,
                Cell: EditableCell,
                hidden: false
            },
            {
                Header: "Contact Details",
                accessor: "mobileNo",
                //  Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false
            },
            {
                Header: " Application Date",
                accessor: "applicationDate",
                Filter: DateRangeColumnFilter,
                filter: dateBetweenFilterFn,
                filterable: true,
                hidden: false,
                Cell: ({ value }) => {
                    if (value == null) {
                        return <span>{value}</span>;
                    } else {
                        const dateOnly = new Date(value);

                        const formattedDate = new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }).format(dateOnly);

                        return <span>{formattedDate}</span>;
                    }
                }
            },

            {
                Header: "Last Status Change",
                accessor: "lastchangedate",
                //  Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ value }) => {
                    if (value == null) {
                        return <span>{value}</span>;
                    } else {
                        const dateOnly = new Date(value);

                        const formattedDate = new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }).format(dateOnly);

                        return <span>{formattedDate}</span>;
                    }
                }
            },
            {
                Header: "Screening Started",
                accessor: "screeningstarted",
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ value }) => {
                    if (value == null) {
                        return <span>{value}</span>;
                    } else {
                        const dateOnly = new Date(value);

                        const formattedDate = new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }).format(dateOnly);

                        return <span>{formattedDate}</span>;
                    }
                }
            },
            {
                Header: "Date Deployed",
                accessor: "datedeployed",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ value }) => {
                    if (value == null) {
                        return <span>{value}</span>;
                    } else {
                        const dateOnly = new Date(value);

                        const formattedDate = new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }).format(dateOnly);

                        return <span>{formattedDate}</span>;
                    }
                }
            },
            {
                Header: "Date Last Worked",
                accessor: "datelastworked",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ value, row: { original } }) => {
                    if (value == null) {
                        return <span>{value}</span>;
                    } else {
                        const dateOnly = new Date(value);

                        const formattedDate = new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }).format(dateOnly);

                        return (
                            <Button variant="primary" onClick={() => {
                                HandleScreeningAvailablityPopups(original.staffID);
                                setScreeningavailablitymodalShow(true);
                            }}>
                                {formattedDate}
                            </Button>
                        )
                    }

                }

            },
            {
                Header: "Days Since Last Shift",
                accessor: "dayssincelastshift",
                //  Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false
            },
            {
                Header: "Docs Last Chased",
                accessor: "docslastchased",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ value }) => {
                    if (value == null) {
                        return <span>{value}</span>;
                    } else {
                        const dateOnly = new Date(value);

                        const formattedDate = new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }).format(dateOnly);

                        return <span>{formattedDate}</span>;
                    }
                }
            },
            {
                Header: "Refs Last Chased",
                accessor: "refslastchased",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ value }) => {
                    if (value == null) {
                        return <span>{value}</span>;
                    } else {
                        const dateOnly = new Date(value);

                        const formattedDate = new Intl.DateTimeFormat('en-GB', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                        }).format(dateOnly);

                        return <span>{formattedDate}</span>;
                    }
                }
            },
            {
                Header: "Prescreen Status",
                accessor: "prescreenstatus",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false,
                Cell: ({ value, row: { original } }) => {
                    return (
                        <Button variant="primary" onClick={() => {
                            HandlePrescreeningPopups(original.staffID);
                            setPrescreenmodalShow(true);
                        }}>
                            {value}
                        </Button>
                    )
                }

            },
            {
                Header: "References",
                accessor: "refs",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false
            },
            {
                Header: "Years Covered",
                accessor: "yearscovered",
                //  Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false
            },
            {
                Header: "Days to Complete",
                accessor: "daysleft",
                //Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                hidden: false
            },
            {
                Header: "Department 1",
                accessor: "dep1",
                //Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: true,
                Cell: EditableCell,
                hidden: false


            },
            {
                Header: "Department 2",
                accessor: "dep2",
                Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: true,
                Cell: EditableCell,
                hidden: false

            },
            {
                Header: "Department 3",
                accessor: "dep3",
                Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: true,
                Cell: EditableCell,
                hidden: false
            },
            {
                Header: "AM",
                accessor: "areaManagerName",
                // Filter: SelectColumnFilter,
                filter: 'equals',
                filterable: false,
                Cell: EditableCell,
                hidden: false
            },

        ]
    );
    const Datecomponent = ({ parentCallback, filterdData }) => {
        const [disabled, setDisabled] = useState(filterdData.Customdate !== 'custom');

        const handleOptionChange = (value) => {

            if (value === "custom") {

                parentCallback({ ...filterdData, Customdate: value });
                setDisabled(false);
            } else {
                setDisabled(true);
                parentCallback({ ...filterdData, AppliedFrom: '', AppliedTo: '', Customdate: value });

            }
        };
        const handelAppliedFromChange = (value) => {

            let customfromValue = value ? moment(value).format('YYYY-MM-DDTHH:mm:ss') : '';
            parentCallback({ ...filterdData, AppliedFrom: customfromValue });

        }

        const handelAppliedToChange = (value) => {



            let customToValue = value ? moment(value).format('YYYY-MM-DDTHH:mm:ss') : '';
            parentCallback({ ...filterdData, AppliedTo: customToValue });

        }
        const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
            <input
                type="text"
                value={value}
                onClick={onClick}
                className="btn btn-light date-input"
                ref={ref}
                readOnly
                style={{ width: '100%' }}
            />
        ));
        return (
            <div className="Applicationdate">
                <section className="firstrow d-flex flex-wrap gap-3">
                    <div className="form-group mb-0">
                        <label>
                            <input
                                type="radio"
                                value="yesterday"
                                checked={filterdData.Customdate ? filterdData.Customdate.includes("yesterday") : false}
                                onChange={(e) => handleOptionChange(e.target.value)}
                                className="label_space me-1"
                            />
                            Yesterday
                        </label>
                    </div>
                    <div className="form-group mb-0">
                        <label>
                            <input
                                type="radio"
                                value="today"
                                checked={filterdData.Customdate ? filterdData.Customdate.includes("today") : false}
                                onChange={(e) => handleOptionChange(e.target.value)}
                                className="label_space me-1"
                            />
                            Today
                        </label>
                    </div>
                    <div className="form-group my-0">
                        <label >
                            <input
                                type="radio"
                                value="Last 7 days"
                                checked={filterdData.Customdate ? filterdData.Customdate.includes("7") : false}
                                onChange={(e) => handleOptionChange(e.target.value)}
                                className="label_space me-1"
                            />
                            Last 7 days
                        </label>
                    </div>
                    <div className="form-group my-0">
                        <label>
                            <input
                                type="radio"
                                value="Last 30 days"
                                checked={filterdData.Customdate ? filterdData.Customdate.includes("30") : false}
                                onChange={(e) => handleOptionChange(e.target.value)}
                                className="label_space me-1"

                            />
                            Last 30 days
                        </label>
                    </div>
                    <div className="form-group my-0">
                        <label>
                            <input
                                type="radio"
                                value="custom"
                                checked={filterdData.Customdate ? filterdData.Customdate.includes("custom") : false}
                                onChange={(e) => handleOptionChange(e.target.value)}
                                className="label_space me-1"
                            />
                            Custom
                        </label>
                    </div>
                </section>
                <section className={`secondrow flex-row  ${filterdData.Customdate.includes("custom") === false ? "d-none" : "d-flex"}`}>
                    <div className="form-group me-2 mb-0">
                        <label htmlFor="AppliedFrom">
                            Applied From:
                        </label>
                        < DatePicker
                            selected={!filterdData.AppliedFrom ? null : new Date(filterdData.AppliedFrom)}
                            onChange={handelAppliedFromChange}
                            isClearable
                            dateFormat="dd/MM/yyyy"
                            customInput={<CustomInput />}

                        />

                    </div>
                    <div className="form-group mb-0">
                        <label htmlFor="AppliedTo">
                            Applied To:
                        </label>
                        < DatePicker
                            selected={!filterdData.AppliedTo ? null : new Date(filterdData.AppliedTo)}
                            onChange={handelAppliedToChange}
                            isClearable
                            dateFormat="dd/MM/yyyy"
                            customInput={<CustomInput />}

                        />

                    </div>
                </section>
            </div>
        );
    };
    const Bulkupdatestaff = (staffrecords) => {


        if (staffrecords.length > 50) {
            window.alert(`You have chosen ${staffrecords.length} staff records.The limit is 50`);

        }
        else {
            setBulkupdatepopupmodal(true);
            setstaffdata(staffrecords);

        }
    }

    const Bulkupdatepopup = ({ show, onHide }) => {
        const [searchTerm, setSearchTerm] = useState("");
        const [IDddls, setIDddls] = useState({ status: null, applicationprofile: null, AM: null, ScreeningOfficer: null });
        var ids = Array.from(new Set(staffdata.map(data => JSON.stringify(data.staffID))));
        const [updatingdata, setupdataingdata] = useState({ staffid: ids.join(","), ScreeningStatusID: null, ScreeningOfficer: null, applicationprofile: null, referer: null, Dep1: null, Dep2: null, Dep3: null, AM: null });


        const handleBulkupdateSubmit = async () => {
            setLoading(true);


            try {
                const response = await fetch(`${apiUrl}/screeningsummary/BulkUpdatestaffrecords`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `bearer ${jwt}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(updatingdata),

                });

                const res = await response.json();
                if (res.message != null) {

                    window.alert(res.message);
                    setLoading(false);
                }
                else
                    if (res.data) {


                        if (res.data === "SUCCESS") {
                            handleFilterSubmit(filtersTorender);
                            onHide();
                            setstaffdata([]);

                        }
                        else {
                            setErrorMessage(res.data);
                        }
                        setLoading(false);
                    }
                    else {
                        window.alert("FAILED TO UPDATE");
                        setLoading(false);
                    }

            } catch (error) {

                setLoading(false);
            }
        }
        const handelSearchInputChange = (event) => {
            setSearchTerm(event.target.value);
        };
        const handelsetvalues = (key, e) => {
            setupdataingdata({ ...updatingdata, [key]: e })
        }
        const removestafffromlist = (resid) => {
            setstaffdata((prevStaffids) =>
                prevStaffids.filter((data) => data.staffID !== resid))
        }

        const Ddls = Object.keys(screeningddls);
        const applicationprofileValue = screeningddls[Ddls[0]];
        const assignedToValue = screeningddls[Ddls[1]];
        const statusValue = screeningddls[Ddls[2]];
        const Dep1value = screeningddls[Ddls[4]];
        const Dep2value = screeningddls[Ddls[5]];
        const Dep3value = screeningddls[Ddls[6]];
        const Areamanger = screeningddls[Ddls[3]];

        const filteredAssignedTo = assignedToValue && assignedToValue.length > 0
            ? assignedToValue.filter((options) => {
                if (options.screeningofficer && options.screeningofficer.trim() !== '') {

                    return options.screeningofficer.toLowerCase().includes(searchTerm.toLowerCase())
                }
                return false;
            }

            )
            : [];
        const filteredApplicationprofile = applicationprofileValue && applicationprofileValue.length > 0
            ? applicationprofileValue.filter((options) => {
                if (options.profilename && options.profilename.trim() !== '') {
                    return options.profilename.toLowerCase().includes(searchTerm.toLowerCase())
                }
                return false;
            }
            )
            : [];
        const filteredstatus = statusValue && statusValue.length > 0
            ? statusValue.filter((options) =>
                options.statusname.toLowerCase().includes(searchTerm.toLowerCase())
            )
            : [];
        const filteredDep1 = Dep1value && Dep1value.length > 0
            ? Dep1value.filter((options) => {
                if (options.workbase && options.workbase.trim() !== '') {
                    return options.workbase.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];

        const filteredDep2 = Dep2value && Dep2value.length > 0
            ? Dep2value.filter((options) => {
                if (options.department2 && options.department2.trim() !== '') {
                    return options.department2.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];
        const filteredDep3 = Dep3value && Dep3value.length > 0
            ? Dep3value.filter((options) => {
                if (options.department3 && options.department3.trim() !== '') {
                    return options.department3.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];
        const filteredAreaManger = Areamanger && Areamanger.length > 0
            ? Areamanger.filter((options) => {
                if (options.areamanger && options.areamanger.trim() !== '') {
                    return options.areamanger.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];



        if (show) {
            return (

                <Modal show={show} onHide={onHide} className="bulk-update-modal">
                    <Modal.Header closeButton>
                        <Modal.Title>Bulk Update</Modal.Title>
                    </Modal.Header>
                    <div className="bulk-update-error " style={ErrorMessage === null ? { display: "none" } : { display: "block" }}>
                        <p style={{ color: 'black' }}>{ErrorMessage}</p>
                    </div>
                    <Modal.Body className="save-filter-body" >
                        <Row style={{ width: "100%" }}>
                            <Col sm={8}>
                                <Form onSubmit={handleBulkupdateSubmit}>
                                    <div class="alert alert-danger d-flex align-items-center justify-content-center" role="alert">
                                        <BsExclamationTriangleFill />
                                        <div>Warning! this action cannot be reversed, proceed with caution</div>
                                    </div>
                                    <div className="d-flex mb-3">
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="Department1" className="mr-2">
                                                Department 1:
                                            </label>
                                            <Dropdown title={updatingdata.dep1} key={updatingdata.dep1} onSelect={(e) => handelsetvalues('Dep1', e)} onClick={e => { setSearchTerm("") }}>
                                                <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2">
                                                    <div className="fixed-width"> {updatingdata.Dep1 || 'Select Department1'}</div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                    {filteredDep1.map((options) => <Dropdown.Item eventKey={options.workbase}>{options.workbase}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>

                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="Department2" className="mr-2">
                                                Department 2:
                                            </label>
                                            <Dropdown title={updatingdata.dep2} key={updatingdata.dep2} onSelect={(e) => handelsetvalues('Dep2', e)} onClick={e => { setSearchTerm("") }}>
                                                <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2">
                                                    <div className="fixed-width"> {updatingdata.Dep2 || 'Select Department1'}</div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                    {filteredDep2.map((options) => <Dropdown.Item eventKey={options.department2}>{options.department2}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="d-flex mb-3">
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="Department3" className="mr-2">
                                                Department 3:
                                            </label>
                                            <Dropdown title={updatingdata.dep3} key={updatingdata.dep3} onSelect={(e) => handelsetvalues('Dep3', e)} onClick={e => { setSearchTerm("") }}>
                                                <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2">
                                                    <div className="fixed-width"> {updatingdata.Dep3 || 'Select Department1'}</div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                    {filteredDep3.map((options) => <Dropdown.Item eventKey={options.department3}>{options.department3}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="AssignedTo" className="mr-2">
                                                Assigned To:
                                            </label>
                                            <Dropdown title={updatingdata.Assignedto} onSelect={(e) => handelsetvalues('ScreeningOfficer', e)} onClick={e => { setSearchTerm("") }}>
                                                <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2" >
                                                    <div className="fixed-width">  {IDddls.ScreeningOfficer || 'Select AssignedTo'}</div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                    {filteredAssignedTo.map((options) => <Dropdown.Item eventKey={options.id} value={options.id} onClick={() => { setIDddls({ ...IDddls, 'ScreeningOfficer': options.screeningofficer }) }}>{options.screeningofficer}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="d-flex mb-3">
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="profile" className="mr-2">
                                                Profile:
                                            </label>
                                            <Dropdown title={updatingdata.profile} onSelect={(e) => handelsetvalues('applicationprofile', e)} onClick={e => { setSearchTerm("") }}>
                                                <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2" >
                                                    <div className="fixed-width">{IDddls.applicationprofile || 'Select Profile'}</div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                    {filteredApplicationprofile.map((options) => <Dropdown.Item eventKey={options.id} value={options.id} onClick={() => { setIDddls({ ...IDddls, 'applicationprofile': options.profilename }) }}>{options.profilename}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="profile" className="mr-2">
                                                Area Manager:
                                            </label>
                                            <Dropdown title={updatingdata.am} onSelect={(e) => handelsetvalues('AM', e)} onClick={e => { setSearchTerm("") }}>
                                                <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2" >
                                                    <div className="fixed-width">{IDddls.AM || 'Select Profile'}</div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                    {filteredAreaManger.map((options) => <Dropdown.Item value={options.id} eventKey={options.id} onClick={() => { setIDddls({ ...IDddls, 'AM': options.areamanger }) }}>{options.areamanger}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="d-flex mb-3">
                                        <div className="form-group flex-grow-1">
                                            <label htmlFor="profile" className="mr-2">
                                                Status:
                                            </label>
                                            <Dropdown title={updatingdata.status} onSelect={(e) => handelsetvalues('ScreeningStatusID', e)} onClick={e => { setSearchTerm("") }}>
                                                <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2" >
                                                    <div className="fixed-width">{IDddls.status || 'Select Profile'}</div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                    {filteredstatus.map((options) => <Dropdown.Item value={options.id} eventKey={options.id} onClick={() => { setIDddls({ ...IDddls, 'status': options.statusname }) }}>{options.statusname}</Dropdown.Item>)}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                        <div className="form-group d-block flex-grow-1">
                                            <label htmlFor="profile">
                                                Referrer:
                                            </label>
                                            <input placeholder={"Enter Referrer"} className="rounded referrer-input" onBlur={(e) => handelsetvalues('referer', e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="d-flex flex-row-reverse">
                                        <Button variant="secondary" onClick={handleBulkupdateSubmit}>
                                            Run update
                                        </Button>
                                        <Button variant="secondary" className="me-3" onClick={onHide}>
                                            Cancel
                                        </Button>
                                    </div>
                                </Form>
                            </Col>
                            <Col sm={4}>
                                <div>
                                    <span>Currently Selected</span>
                                    <div className="currently-selected">
                                        {
                                            staffdata.map((data) => {
                                                return (
                                                    <div key={data.staffID} className="d-flex align-items-center justify-content-between">
                                                        <span>{data.staffID} | {data.firstname} {data.lastname}</span>
                                                        <a className="remove-selected" onClick={(e) => removestafffromlist(data.staffID)}><BsTrash3Fill color="white" /></a>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
            )
        }

    }


    const FilterForm = ({ onSubmit, onSave, onSaveAs}) => {

        const [searchTerm, setSearchTerm] = useState("");
        const [filterdData, setfilterData] = useState(intialfiltervalues);
        const [firsttwofilters, setfirsttwofilters] = useState(intialtwofiltervalues);
        const [filterName, setFilterName] = useState(selectedfiltername.name);
        const [filterError, setFilterError] = useState(null);
       
        
        const [isstatusSelectAll, setisstatusSelectAll] = useState(false);
        const [istableColumnsSelectAll, setistableColumnsSelectAll] = useState(true);
        const extractBooleanValues = (obj) => {
            const result = [];
            for (const key in obj) {
                if (typeof obj[key] === 'boolean' && obj[key] === true) {
                    result.push(key);
                }
            }
            return result;
        };
        const covnertToNominalcase = (data) => {
            //here we are converting into same values as intitalfiltervalues
            const initialFilterValuesKeys = Object.keys(intialfiltervalues);
            const lowerCaseAnotherObject = {};
            for (let key in data) {
                lowerCaseAnotherObject[key.toLowerCase()] = data[key];
            }
            const matchingKeyValuePairs = {};
            initialFilterValuesKeys.forEach(key => {
                let lowerCaseKey = key.toLowerCase();
                if (lowerCaseAnotherObject.hasOwnProperty(lowerCaseKey)) {
                    matchingKeyValuePairs[key] = lowerCaseAnotherObject[lowerCaseKey];
                }
            });
            return matchingKeyValuePairs;
        }

        const [visibleColumns, setVisibleColumns] = useState(columns.map((col) => col.accessor));

        useEffect(() => {
            if (JSON.stringify(filtersTorender) !== JSON.stringify(intialfiltervalues)) {
                setfilterData(filtersTorender);
                setfirsttwofilters(saveFilternames);
                ////while applying filter from saved filter it we are captilizing the names for filter,
                ////here we are converting into same values as intitalfiltervalues
                //const initialFilterValuesKeys = Object.keys(intialfiltervalues);
                //const lowerCaseAnotherObject = {};
                //for (let key in filtersTorender) {
                //    lowerCaseAnotherObject[key.toLowerCase()] = filtersTorender[key];
                //}
                //const matchingKeyValuePairs = {};
                //initialFilterValuesKeys.forEach(key => {
                //    let lowerCaseKey = key.toLowerCase();
                //    if (lowerCaseAnotherObject.hasOwnProperty(lowerCaseKey)) {
                //        matchingKeyValuePairs[key] = lowerCaseAnotherObject[lowerCaseKey];
                //    }
                //});
                const matchingKeyValuePairs = covnertToNominalcase(filtersTorender);
                setVisibleColumns((prevVisibleColumns) => {
                    const columnStates = extractBooleanValues(matchingKeyValuePairs);

                    return prevVisibleColumns.map((col) => {
                        if (columnStates.includes(col)) {
                            return col;
                        }
                        return null;
                    }).filter(Boolean);
                });
                //This code is only comes into effect when user selectes the filter from dropdown
                if (selectedfiltername.id !== '') {
                    const profileObject = applicationprofileValues.find(item => item.id.toString() === filtersTorender.Profile);
                    if (profileObject) {
                        setfirsttwofilters(prevState => ({ ...prevState, Profile: profileObject.profilename }));
                    }
                    const AssignedtoObject = assignedToValues.find(item => item.id.toString() === filtersTorender.AssignedTo);
                    if (AssignedtoObject) {
                        setfirsttwofilters(prevState => ({ ...prevState, AssignedTo: AssignedtoObject.screeningofficer }));
                    }

                    const statusIds = filtersTorender.Status.split(',');
                    const statusNames = statusIds.map(id => {
                        const statusObject = statusValues.find(item => item.id.toString() === id);
                        return statusObject ? statusObject.statusname : '';
                    });
                    if (statusNames) {
                        setfirsttwofilters(prevState => ({ ...prevState, Status: statusNames }));
                    }
                }
            }
        }, [filtersTorender]);


        const handleReset = (e) => {
            e.preventDefault();
            setfiltersTorender(intialfiltervalues);
            setfilterData(intialfiltervalues);
            setfirsttwofilters(intialtwofiltervalues);
            setSelectedfiltername({ id: '', name: '' });
            setReset(!reset);
            setScreeningData([]);
            setForfiltertags({
                Allfilters: intialfiltervalues,
                checkboxfilters: intialtwofiltervalues
            });

        };

        const handleFilterName = (e) => {
            setFilterName(e.target.value);
            if (e.target.value != selectedfiltername.name && FilterNames.some(filter => e.target.value == filter.name)) {
                setFilterError("Filter name exists");   
            }
            else {
                setFilterError(null);
            }
        }
        
        const handleFilterSearchTerm = (e) => {
            setfilterData({...filterdData, SearchTerm: e.target.value});
        }

        const handelLocation = (e) => {
            setfilterData({ ...filterdData, Location: e.target.value });
        }

        const handelReferer = (e) => {
            setfilterData({ ...filterdData, Referercode: e.target.value });
        }

        const handelSearchInputChange = (event) => {
            setSearchTerm(event.target.value);
        };



        const handelStatusChange = (e, value, checked) => {
            if (e === "selectAll") {
                // Handle Select All or Deselect All
                const allStatuses = filteredstatus.map(option => option.statusname); // All status names
                const allStatusIds = filteredstatus.map(option => option.id); // All status IDs

                if (checked) {
                    // Select All
                    setfilterData((prevData) => ({
                        ...prevData,
                        Status: allStatusIds.join(","),
                    }));
                    setfirsttwofilters((prevState) => ({
                        ...prevState,
                        Status: allStatuses,
                    }));

                } else {
                    // Deselect All
                    setfilterData((prevData) => ({
                        ...prevData,
                        Status: '',
                    }));
                    setfirsttwofilters((prevState) => ({
                        ...prevState,
                        Status: [],
                    }));

                }
                setisstatusSelectAll(checked);

            }
            else {
                setfilterData((prevData) => {
                    const updatedValue = Array.isArray(value) ? value.join(",") : value.toString();

                    if (checked) {

                        const updatedStatus = prevData.Status ? `${prevData.Status},${updatedValue}` : updatedValue;
                        return {
                            ...prevData,
                            Status: updatedStatus,
                        };
                    } else {

                        const updatedStatus = prevData.Status
                            ? prevData.Status.split(',').filter((status) => status !== updatedValue).join(',')
                            : '';
                        return {
                            ...prevData,
                            Status: updatedStatus,
                        };
                    }
                });
                setfirsttwofilters((prevState) => {

                    if (prevState.Status.includes(e)) {
                        return {
                            ...prevState,
                            Status: prevState.Status.filter((name) => name !== e),
                        };
                    } else {
                        return {
                            ...prevState,
                            Status: [...prevState.Status, e],
                        };
                    }
                });
            }


        }
        const handelProfileChange = (e, value) => {
            setfilterData({ ...filterdData, Profile: value });
            setfirsttwofilters({ ...firsttwofilters, Profile: e });
        }

        const handelAssignedToChange = (e, value) => {
            setfilterData({ ...filterdData, AssignedTo: value });
            setfirsttwofilters({ ...firsttwofilters, AssignedTo: e });
        }
        const handelDepartment1Change = (value) => {
            setfilterData({ ...filterdData, Department1: value });
        }
        const handelDepartment2Change = (value) => {
            setfilterData({ ...filterdData, Department2: value });
        }
        const handelDepartment3Change = (value) => {
            setfilterData({ ...filterdData, Department3: value });
        }

        const handelEngagementChange = (value) => {
            setfilterData({ ...filterdData, Engagement: value });
        }
        const handleslider = (value) => {
            const values = value == 0 ? '' : value;
            setfilterData({ ...filterdData, Distance: values.toString() });
        }
        const handleColumnVisibilityChange = (id, isVisible) => {
            if (id === "selectAll") {

                const matchingKeyValuePairs = covnertToNominalcase(filterdData);
                // Extract boolean fields from matchingKeyValuePairs
                const allBooleanFields = Object.entries(matchingKeyValuePairs).filter(([key, value]) => typeof value === "boolean");

                // Extract keys
                const allKeys = allBooleanFields.map(([key]) => key);


                // Update filterData and visibleColumns
                setfilterData((prevData) => ({
                    ...prevData,
                    ...Object.fromEntries(allKeys.map((key) => [key, isVisible])),
                }));


                setVisibleColumns((prevVisibleColumns) => {
                    if (isVisible) {
                        // Add all boolean columns to visibleColumns
                        return [...new Set([...prevVisibleColumns, ...allKeys])];
                    } else {
                        // Remove all boolean columns from visibleColumns
                        return prevVisibleColumns.filter((col) => !allKeys.includes(col));
                    }
                });
                setistableColumnsSelectAll(isVisible);

            } else {
                // Handle individual column changes
                setfilterData({
                    ...filterdData,
                    [id]: isVisible,
                });

                setVisibleColumns((prevVisibleColumns) => {
                    if (prevVisibleColumns.includes(id)) {
                        return prevVisibleColumns.filter((col) => col !== id);
                    } else {
                        return [...prevVisibleColumns, id];
                    }
                });
            }
        };


        const handleSubmit = (e) => {
            e.preventDefault();
            setsaveFilternames(firsttwofilters);
            setSelectedfiltername({id: '', name: '' });
            onSubmit(filterdData);
            setForfiltertags({ Allfilters: filterdData, checkboxfilters: firsttwofilters });

        };
        const handleSave = (e) => {
            e.preventDefault();

            if (JSON.stringify(filterdData) === JSON.stringify(intialfiltervalues)) {
                window.alert('Please select the filters to save');
            }
            else {   
                selectedfiltername.name = filterName;
                onSave(filterdData);
                setsaveFilternames(firsttwofilters);
            }
            setForfiltertags({ Allfilters: filterdData, checkboxfilters: firsttwofilters });
        };
        
        const handleSaveAs = (e) => {
            e.preventDefault();

            if (JSON.stringify(filterdData) === JSON.stringify(intialfiltervalues)) {
                window.alert('Please select the filters to save');
            }
            else {
                onSaveAs(filterdData, filterName);
                setsaveFilternames(firsttwofilters);
            }
            setForfiltertags({ Allfilters: filterdData, checkboxfilters: firsttwofilters });
        }


        const Ddls = Object.keys(screeningddls);
        const applicationprofileValues = screeningddls[Ddls[0]];
        const assignedToValues = screeningddls[Ddls[1]];
        const statusValues = screeningddls[Ddls[2]];
        const Dep1values = screeningddls[Ddls[4]];
        const Dep2values = screeningddls[Ddls[5]];
        const Dep3values = screeningddls[Ddls[6]];
        const Engagement = screeningddls[Ddls[7]];

        //search section for dropdowns
        const filteredAssignedTo = assignedToValues && assignedToValues.length > 0
            ? assignedToValues.filter((options) => {
                if (options.screeningofficer && options.screeningofficer.trim() !== '') {

                    return options.screeningofficer.toLowerCase().includes(searchTerm.toLowerCase())
                }
                return false;
            }

            )
            : [];
        const filteredApplicationprofile = applicationprofileValues && applicationprofileValues.length > 0
            ? applicationprofileValues.filter((options) => {
                if (options.profilename && options.profilename.trim() !== '') {
                    return options.profilename.toLowerCase().includes(searchTerm.toLowerCase())
                }
                return false;
            }
            )
            : [];
        const filteredstatus = statusValues && statusValues.length > 0
            ? statusValues.filter((options) =>
                options.statusname.toLowerCase().includes(searchTerm.toLowerCase())
            )
            : [];
        const filteredDep1 = Dep1values && Dep1values.length > 0
            ? Dep1values.filter((options) => {
                if (options.workbase && options.workbase.trim() !== '') {
                    return options.workbase.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];

        const filteredDep2 = Dep2values && Dep2values.length > 0
            ? Dep2values.filter((options) => {
                if (options.department2 && options.department2.trim() !== '') {
                    return options.department2.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];
        const filteredDep3 = Dep3values && Dep3values.length > 0
            ? Dep3values.filter((options) => {
                if (options.department3 && options.department3.trim() !== '') {
                    return options.department3.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];
        const filteredEngagement = Engagement && Engagement.length > 0
            ? Engagement.filter((options) => {
                if (options.engagement && options.engagement.trim() !== '') {
                    return options.engagement.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];
        const filteredcustomization = columns && columns.length > 0
            ? columns.filter((options) => {
                if (options.Header && options.Header.trim() !== '') {
                    return options.Header//.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];


        const handleToggleColumns = (checkboxstype) => {
            if (checkboxstype === "status") {
                handelStatusChange("selectAll", null, !isstatusSelectAll);
            } else {
                handleColumnVisibilityChange("selectAll", !istableColumnsSelectAll);
            }
        };
        const allStatusChecked =
            filteredstatus.length > 0 &&
            filteredstatus.every(
                (option) =>
                    firsttwofilters &&
                    firsttwofilters.Status &&
                    firsttwofilters.Status.includes(option.statusname)
            );

        const allTableColumnsChecked =
            filteredcustomization.filter((column) => !column.hidden).length > 0 &&
            filteredcustomization
                .filter((column) => !column.hidden)
                .every((column) => visibleColumns.includes(column.accessor));
        useEffect(() => {
            setisstatusSelectAll(allStatusChecked);
            setistableColumnsSelectAll(allTableColumnsChecked);
        }, [allStatusChecked, allTableColumnsChecked])
        const tooltip = (
            <Tooltip id={`search-tooltip`}>
                Enter a keyword or a date in the format DD/MM/YYYY
            </Tooltip>
        );

        if (isddlloaded) {
            return (
                <>

                    <form onSubmit={handleSubmit} className="form-inline container two-col-filters">
                        <div className="row">
                            <div className="col-6 border-end">
                                <div className="row">
                                    <h4 className="col-6" >Status</h4>
                                    <a className="col-6 text-end" variant="link" onClick={() => handleToggleColumns("status")}>
                                        {isstatusSelectAll ? "Deselect All" : "Select All"}
                                    </a>
                                </div>
                                {filteredstatus.map((option) => (
                                    <div style={{ display: 'flex' }} key={option.id}>
                                        <input
                                            type="checkbox"
                                            className="dropdown-checkbox"
                                            checked={firsttwofilters && firsttwofilters.Status && firsttwofilters.Status.includes(option.statusname)}
                                            id={`status-${option.id}`}
                                            value={option.id}
                                            onChange={(e) => handelStatusChange(option.statusname, option.id, e.target.checked)}
                                        />
                                        <label htmlFor={`status-${option.id}`}>{option.statusname}</label>
                                    </div>
                                ))}
                                <div className="row">
                                    <h4 className="col-6 my-2">Table columns:</h4>
                                    <a className="col-6 text-end" variant="link" onClick={() => handleToggleColumns("TableCloumns")}>
                                        {istableColumnsSelectAll ? "Deselect All" : "Select All"}
                                    </a>
                                </div>
                                {filteredcustomization.map((column, index) => (
                                    !column.hidden && (
                                        <div key={column.accessor}>
                                            <input
                                                type="checkbox"
                                                className="dropdown-checkbox"
                                                checked={visibleColumns.includes(column.accessor)}
                                                onChange={(e) => {
                                                    handleColumnVisibilityChange(column.accessor, e.target.checked)
                                                }}
                                            />
                                            <span>{column.Header}</span>
                                        </div>
                                    )
                                ))}
                            </div>
                            <div className="col-6">
                                <h4>Filters: {selectedfiltername.name}</h4>
                                <div className="filter_Container_one mb-3">
                                    {selectedfiltername.name &&
                                        <div className="form-group location-container">
                                            <label htmlFor="filtername" className="mr-2">
                                                Filter Name:
                                            </label>
                                            <input type="text" id="filtername" className="form-control mr-2" 
                                                   value={filterName} maxLength="50"
                                                    onChange={handleFilterName}/>
                                            {filterError &&
                                                <label style={{ color: 'red' }}>{filterError}</label>
                                            }
                                        </div>
                                    }
                                    <div className="form-group location-container">
                                        <OverlayTrigger overlay={tooltip} placement="top">
                                            <input type="text" id="keywords" placeholder="Keywords"
                                                   className="form-control mr-2" maxLength="50"
                                                   value={filterdData.SearchTerm} onChange={handleFilterSearchTerm}/>
                                        </OverlayTrigger>
                                    </div>
                                    <div className="form-group location-container">
                                        <label htmlFor="location" className="mr-2">
                                            Location:
                                        </label>
                                        <input type="text" id="location" placeholder="post code/town/address"
                                               className="form-control mr-2" value={filterdData.Location}
                                               onChange={handelLocation} maxLength="50"/>
                                        <SliderWithInputFormControl handleslider={handleslider} reset={reset}/>
                                    </div>


                                </div>

                                <div className="col-12">
                                       <div className="filter_Container_one mb-3">
                                    <div className="form-group location-container">
                                        <label htmlFor="GUT3NB3RG" className="mr-2">
                                            Referrer:
                                        </label>
                                            <input type="text" id="referer" placeholder="Enter referrer" className="form-control mr-2" value={filterdData.Referercode} onChange={handelReferer} maxLength="50" />
                                       
                                    </div>

                                    </div>

                                </div>
                                <div className="filter_Container_two">


                                    <div className="form-group app_date_container">
                                        <label htmlFor="Application Date" className="mr-2">
                                            Application Date:
                                        </label>
                                        <div className="application-date-parent">
                                            <Datecomponent parentCallback={setfilterData} filterdData={filterdData}/>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label htmlFor="profile" className="mr-2">
                                            Profile:
                                        </label>
                                        <Dropdown title={firsttwofilters.Profile} onClick={e => { setSearchTerm("") }}>
                                            <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2" >
                                                <div className="fixed-width">{firsttwofilters.Profile || 'Select Profile'}</div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                {filteredApplicationprofile.map((options) => <Dropdown.Item onClick={(e) => handelProfileChange(options.profilename, options.id.toString())} eventKey={options.id} value={options.id}>{options.profilename}</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>


                                    <div className="form-group">
                                        <label htmlFor="Engagement" className="mr-2">
                                            Engagement:
                                        </label>
                                        <Dropdown title={filterdData.Engagement} onSelect={handelEngagementChange} onClick={e => { setSearchTerm("") }}>
                                            <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2">
                                                <div className="fixed-width">{filterdData.Engagement || 'Select Engagement'}</div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                {filteredEngagement.map((options) => <Dropdown.Item eventKey={options.engagement}>{options.engagement}</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="Department1" className="mr-2">
                                            Department 1:
                                        </label>
                                        <Dropdown title={filterdData.Department1} onSelect={handelDepartment1Change} onClick={e => { setSearchTerm("") }}>
                                            <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2">
                                                <div className="fixed-width"> {filterdData.Department1 || 'Select Department 1'}</div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                {filteredDep1.map((options) => <Dropdown.Item eventKey={options.workbase}>{options.workbase}</Dropdown.Item>

                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="Department2" className="mr-2">
                                            Department 2:
                                        </label>
                                        <Dropdown title={filterdData.Department2} onSelect={handelDepartment2Change} onClick={e => { setSearchTerm("") }}>
                                            <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2">
                                                <div className="fixed-width">{filterdData.Department2 || 'Select Department 2'}</div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                {filteredDep2.map((options) => <Dropdown.Item eventKey={options.department2}>{options.department2}</Dropdown.Item>

                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                    <div className="form-group" style={{ display: 'block' }}>
                                        <label htmlFor="Department3" className="mr-2">
                                            Department 3:
                                        </label>
                                        <Dropdown title={filterdData.Department3} onSelect={handelDepartment3Change} onClick={e => { setSearchTerm("") }}>
                                            <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2 ">
                                                <div className="fixed-width">{filterdData.Department3 || 'Select Department 3'}</div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                {filteredDep3.map((options) => <Dropdown.Item eventKey={options.department3}>{options.department3}</Dropdown.Item>

                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>

                                </div>

                                <div className="filter_Container_three">
                                    <div className="form-group">
                                        <label htmlFor="AssignedTo" className="mr-2">
                                            Assigned To:
                                        </label>
                                        <Dropdown title={firsttwofilters.AssignedTo} onClick={e => { setSearchTerm("") }}>
                                            <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2" >
                                                <div className="fixed-width">  {firsttwofilters.AssignedTo || 'Select Assigned To'}</div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                                {filteredAssignedTo.map((options) => <Dropdown.Item onClick={(e) => handelAssignedToChange(options.screeningofficer, options.id.toString())} eventKey={options.id} value={options.id} >{options.screeningofficer}</Dropdown.Item>
                                                )}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>



                                </div>
                                <div className="submit-container">
                                    {selectedfiltername.id ?
                                        <div>
                                            <Button type="submit" variant="primary submit-filter">
                                                Apply
                                            </Button>
                                            <div className="d-flex my-2">
                                                <Button onClick={handleSave} 
                                                        class="btn-save" 
                                                        variant="secondary submit-filter me-1"
                                                        disabled={filterError || filterdData.DefaultFilter}>
                                                    Save
                                                </Button>
                                                <Button onClick={handleSaveAs} 
                                                        variant="secondary submit-filter ms-1" 
                                                        disabled={filterName == selectedfiltername.name || filterError || filterdData.DefaultFilter}>
                                                    Save As
                                                </Button>
                                            </div>
                                        </div>
                                        :
                                        <div className="d-flex my-4">
                                            <Button onClick={handleSave} variant="secondary submit-filter me-1">
                                                Save Filters
                                            </Button>
                                            <Button type="submit" variant="secondary submit-filter ms-1">
                                                Apply Filters
                                            </Button>
                                        </div>
                                    }
                                    <div className="mb-4">
                                        <Button variant="submit-filter outline" onClick={handleReset}>Reset Filters</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                </>
            )
        }
    }
    function Updatefiltertags(filtersTorender) {


        const Ddls = Object.keys(screeningddls);
        const applicationprofileValues = screeningddls[Ddls[0]];
        const assignedToValues = screeningddls[Ddls[1]];
        const statusValues = screeningddls[Ddls[2]];


        if (JSON.stringify(filtersTorender) !== JSON.stringify(intialfiltervalues)) {
            setAllfiltersvals(filtersTorender);

            //while applying filter from saved filter it we are captilizing the names for filter,
            //here we are converting into same values as intitalfiltervalues
            const initialFilterValuesKeys = Object.keys(intialfiltervalues);
            const lowerCaseAnotherObject = {};
            for (let key in filtersTorender) {
                lowerCaseAnotherObject[key.toLowerCase()] = filtersTorender[key];
            }
            const matchingKeyValuePairs = {};
            initialFilterValuesKeys.forEach(key => {
                let lowerCaseKey = key.toLowerCase();
                if (lowerCaseAnotherObject.hasOwnProperty(lowerCaseKey)) {
                    matchingKeyValuePairs[key] = lowerCaseAnotherObject[lowerCaseKey];
                }
            });

            if (selectedfiltername.id !== '') {
                const profileObject = applicationprofileValues.find(item => item.id.toString() === filtersTorender.Profile);
                if (profileObject) {
                    setcheckboxfiltersvals(prevState => ({ ...prevState, Profile: profileObject.profilename }));
                }
                const AssignedtoObject = assignedToValues.find(item => item.id.toString() === filtersTorender.AssignedTo);
                if (AssignedtoObject) {
                    setcheckboxfiltersvals(prevState => ({ ...prevState, AssignedTo: AssignedtoObject.screeningofficer }));
                }

                const statusIds = filtersTorender.Status.split(',');
                const statusNames = statusIds.map(id => {
                    const statusObject = statusValues.find(item => item.id.toString() === id);
                    return statusObject ? statusObject.statusname : '';
                });
                if (statusNames) {
                    setcheckboxfiltersvals(prevState => ({ ...prevState, Status: statusNames }));
                }
            }

        }
        else {
            setAllfiltersvals(filtersTorender);
        }

    }

    useEffect(() => {
        setForfiltertags({ Allfilters: Allfiltersvals, checkboxfilters: checkboxfiltersvals });
    }, [Allfiltersvals, checkboxfiltersvals])

    const Savedfilter = () => {
        const [searchTerm, setSearchTerm] = useState("");


        const handelSearchInputChange = (event) => {
            setSearchTerm(event.target.value);
        };
        const handleSaveFilter = async (filterName) => {
            setLoading(true);
            setfiltersTorender(savedfilterdata);
            try {

                const response = await fetch(`${apiUrl}/screeningsummary/SaveScreeningSummaryDataWithFilter`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `bearer ${jwt}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ savedfilterdata, filterName }),
                });
                if (response.status == 204 || response.statusText == "No Content") {
                    window.alert("We've searched everywhere but we couldn’t find any applicants that match your current filter criteria");
                    setLoading(false);
                    setScreeningData([]);
                    setForfiltertags({
                        Allfilters: intialfiltervalues,
                        checkboxfilters: intialtwofiltervalues
                    });

                } else {
                    const result = await response.json();
                    setScreeningData(result);
                    fetchDDLforFilters();
                    setLoading(false);

                }

            } catch (error) {
                console.error(error);
            }

            setShowSaveModal(false);


        };

        const FilteredFilternames = FilterNames && FilterNames.length > 0
            ? FilterNames.filter((options) => {
                if (options.name && options.name.trim() !== '' && !options.defaultFilter) {
                    return options.name.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];

        const DefaultFilternames = FilterNames && FilterNames.length > 0
            ? FilterNames.filter((options) => {
                if (options.name && options.name.trim() !== '' && options.defaultFilter) {
                    return options.name.toLowerCase().includes(searchTerm.toLowerCase());
                }
                return false;
            })
            : [];

        const handelinputchanges = (e) => {
            var value = e.target.value;
            setEditedName(value);
        }

        if (isddlloaded) {

            return (

                <><div className="FilterNameDDL" title="Select Saved Filters">
                    <Dropdown onClick={e => { setSearchTerm(""); }}>
                        <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2 saved-filters">
                            <div className="fixed-width">
                                {isEditing ? (
                                    <>
                                        <input
                                            autoFocus="autoFocus"
                                            value={editedName}
                                            onChange={(e) => {
                                                handelinputchanges(e);

                                            }} />
                                    </>
                                ) : (
                                    selectedfiltername.name === '' ? "Select Saved Filters" : selectedfiltername.name
                                )}
                            </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <input type="text" placeholder="Search..." value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                            {DefaultFilternames.map((filter) => <SavedFilterItem options={filter} key={filter.id} canEdit={false} />)}
                            <hr />
                            {FilteredFilternames.map((filter) => <SavedFilterItem options={filter} key={filter.id} canEdit={true} />)}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                </>
            );
        }
    }

    const SavedFilterItem = (props) => {
        function capitalizeFirstLetter(str) {
            if (!str || typeof str !== 'string') return str;
            return str.charAt(0).toUpperCase() + str.slice(1);
        }

        function capitalizeKeys(obj) {
            const capitalizedObj = {};
            for (const key in obj) {
                const capitalizedKey = capitalizeFirstLetter(key);
                capitalizedObj[capitalizedKey] = obj[key];
            }
            return capitalizedObj;
        }

        const handelfilterApply = async (e, i) => {

            let id = e;
            let filtername = i;

            setLoading(true);
            try {
                const response = await fetch(`${apiUrl}/screeningsummary/GetSSDataWithFiltersSaved`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `bearer ${jwt}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ id: id, filtername: filtername }),

                });


                const result = await response.json();
                if (result.message != null) {
                    window.alert(result.message);
                    setLoading(false);
                }
                else if (result.data) {
                    const capitalizedResult = {
                        //sSummaryData: result.sSummaryData.map(capitalizeKeys),
                        sSummaryHeaders: capitalizeKeys(result.data.sSummaryHeaders),
                    };

                    setScreeningData(result.data.sSummaryData);
                    setfiltersTorender(capitalizedResult.sSummaryHeaders);
                    setLoading(false);


                }
                else {
                    window.alert("We've searched everywhere but we couldn’t find any applicants that match your current filter criteria");
                    setLoading(false);
                    setScreeningData([]);
                    setForfiltertags({
                        Allfilters: intialfiltervalues,
                        checkboxfilters: intialtwofiltervalues
                    });
                }

            } catch (error) {
                console.error(error);
                setLoading(false);
            }
            setSelectedfiltername({ id: e.toString(), name: i });


        }


        const onDeletefilter = async (deletefilterid) => {

            try {
                const response = await fetch(`${apiUrl}/screeningsummary/DeleteSelectedfilter/${deletefilterid}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `bearer ${jwt}`,
                    },
                });

                if (response.ok) {

                    fetchDDLforFilters();
                    setSelectedfiltername({ id: '', name: '' });
                } else {

                    const results = await response.json();
                    window.alert(results.value);

                }

            } catch (error) {

                console.error('Fetch error:', error);
            }
        }

        const handelApplyfilters = (e, i) => {

            handelfilterApply(e, i);

        }

        const handleDeleteFilter = (id, name) => {
            onDeletefilter(id);
        };

        if (isddlloaded) {
            return (
                <>
                    <div className="d-flex justify-content-between" key={props.options.id}>
                        <Dropdown.Item eventKey={props.options.id} >
                            <span className="w-100 d-flex align-items-center justify-content-between">
                                <a onClick={(e) => handelApplyfilters(props.options.id, props.options.name)}>
                                    {props.options.name}
                                </a>
                                <div>
                                    {selectedfiltername.id !== '' && selectedfiltername.id == props.options.id &&
                                        <div style={{ display: 'flex', gap: '15px' }}>
                                           {props.canEdit &&
                                                <button className="buttonhide"
                                                    onClick={(e) => handleDeleteFilter(selectedfiltername.id)}>
                                                    <BsTrashFill />
                                                </button>
                                            }
                                        </div>}
                                </div>
                            </span>
                        </Dropdown.Item>
                    </div>
                </>
            );
        }
    }

    const Companyfilter = () => {
        const [searchTerm, setSearchTerm] = useState("");


        const handelSearchInputChange = (event) => {
            setSearchTerm(event.target.value);
        };
        const handelCompanychange = (companydb) => {
            handelcompanyswitch(companydb);
            setCompanyNameslist(companydb);
        }

        const handelcompanyswitch = async (comp) => {

            setchangepswdmodal(true);

        }

        const filteredCompanies = ListofCompanies && ListofCompanies.length > 0 ? ListofCompanies.filter((option) =>
            option.companyName == null ? '' : option.companyName.toLowerCase().includes(searchTerm.toLowerCase())

        ) : [];

        if (isddlloaded) {
            return (
                <>
                    <div className="form-group">
                        <div className="CompanyNamesDDL">
                            {coid === '40' && ListofCompanies && (
                                <div>
                                    <Dropdown onSelect={handelCompanychange}>
                                        <Dropdown.Toggle variant="light" id="dropdown-split-basic" className="mr-2 c247_dropdown">
                                            Select Companies
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu>
                                            <input type="text" placeholder="Search companies" value={searchTerm} className="search-input" onChange={handelSearchInputChange} />
                                            {filteredCompanies.map((options) => <Dropdown.Item eventKey={options.companyID} key={options.companyID}>{options.companyName}</Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            )}

                        </div>
                    </div>
                    <Passwordconfirmationpswd show={changepswdmodal} onHide={() => { setchangepswdmodal(false); }} />
                </>
            );
        }

    }
    const handleFilterSubmit = async (filtervalues) => {
        setLoading(true);
        setfiltersTorender(filtervalues);

        try {
            const response = await fetch(`${apiUrl}/screeningsummary/GetScreeningSummaryDataWithFilter`, {
                method: 'POST',
                headers: {
                    "Authorization": `bearer ${jwt}`,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(filtervalues),

            });

            const res = await response.json();
            if (res.message != null) {

                window.alert(res.message);
                setLoading(false);
            }
            else if (res.data) {


                setScreeningData(res.data);
                setLoading(false);
            }
            else {
                window.alert("We've searched everywhere but we couldn’t find any applicants that match your current filter criteria");
                setLoading(false);
                setScreeningData([]);
                setForfiltertags({
                    Allfilters: intialfiltervalues,
                    checkboxfilters: intialtwofiltervalues
                });
            }

        } catch (error) {
            console.error(error);
            setLoading(false);
        }
    };

    const Topfilter = ({ onhide }) => {


        const handleFilterApply = (filtervals) => {
            handleFilterSubmit(filtervals);
            if (screeningData) {
                onhide();
            }
        }

        const handleSaveFilter = async (filterName, filterInfo) => {
            setLoading(true);
            setfiltersTorender(filterInfo);
            
            const filterId = selectedfiltername.id || 0;
            
            try {

                const response = await fetch(`${apiUrl}/screeningsummary/SaveScreeningSummaryDataWithFilter`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `bearer ${jwt}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({filterId, savedfilterdata: filterInfo, filterName}),
                });

                const result = await response.json();
                if (result.message) {
                    window.alert(result.message);

                }
                else if (result.data == null || result.data == undefined) {
                    window.alert("We've searched everywhere but we couldn’t find any applicants that match your current filter criteria");
                    setLoading(false);
                    setScreeningData([]);
                    setForfiltertags({
                        Allfilters: intialfiltervalues,
                        checkboxfilters: intialtwofiltervalues
                    });
                }
                else {
                    setScreeningData(result.data);
                    setSelectedfiltername({ id: result.filterId, name: filterName });
                }
                fetchDDLforFilters();
                
                setLoading(false);



            } catch (error) {
                console.error(error);
            }

            setShowSaveModal(false);


        };

        const handelsaveFilter = (filterinfo) => {
            setSavedfilterdata(filterinfo);
            if (!selectedfiltername.name) {
                setShowSaveModal(true);
                // onhide();
            }
            else {
                handleSaveFilter(selectedfiltername.name, filterinfo);
            }
        }
        
        const handleSaveAsFilter = (filterinfo, newFilterName) => {
            setSavedfilterdata(filterinfo);
            selectedfiltername.id = "";
            handleSaveFilter(newFilterName, filterinfo);
        }

        return (
            <div>

                < FilterForm onSubmit={handleFilterApply} onSave={handelsaveFilter} onSaveAs={handleSaveAsFilter}/>

                <SaveFilterModal show={showSaveModal} 
                                 handleClose={() => setShowSaveModal(false)} 
                                 handleSave={handleSaveFilter} filters={savedfilterdata} />
            </div>
        );
    };
    const handleGlobalFilterChange = (filterValue) => {
        setglobalFilterValue(filterValue);


    };
    const handelSearchfilter = () => {
        return globalFilterValue;

    }


    const [skipPageReset, setSkipPageReset] = React.useState(false)
    const updateMyData = async (rowIndex, columnId, value, dropdownid, staffid, headervalue) => {
        setLoading(true);
        try {
            if (headervalue == "Department 1" || headervalue == "Department 2" || headervalue == "Department 3" || headervalue == "Referrer") {


                const response = await fetch(`${apiUrl}/screeningsummary/UpdateStaffRecords`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `bearer ${jwt}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        staffid: staffid,
                        [headervalue]: value,

                    }),
                });
                if (response.ok) {
                    setLoading(false);

                } else {

                    const results = await response.json();
                    window.alert(results.value);
                    setLoading(false);

                }
            }
            else {
                const response = await fetch(`${apiUrl}/screeningsummary/UpdateStaffRecords`, {
                    method: 'POST',
                    headers: {
                        "Authorization": `bearer ${jwt}`,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        staffid: staffid,
                        [headervalue]: dropdownid,

                    }),
                });
                if (response.ok) {
                    setLoading(false);

                    setScreeningData((prevData) => {
                        const updatedData = [...prevData];
                        updatedData[rowIndex] = {
                            ...updatedData[rowIndex],
                            [columnId]: value,
                        };

                        // If updating statusDescription, also update lastchangedate
                        if (columnId === "statusDescription") {
                            updatedData[rowIndex]["lastchangedate"] = new Date().toISOString();
                        }

                        return updatedData;
                    });

                } else {

                    const results = await response.json();
                    window.alert(results.value);
                    setLoading(false);

                }
            }

        }
        catch (error) {
            console.error('Error during API call:', error);

        }

        // We also turn on the flag to not reset the page
        setSkipPageReset(true);
        setScreeningData(old =>
            old.map((row, index) => {
                if (index === rowIndex) {
                    return {
                        ...old[rowIndex],
                        [columnId]: value,
                    }
                }
                return row

            })

        )
        handelSearchfilter();

    }
    React.useEffect(() => {
        setSkipPageReset(false)
    }, [screeningData])

    const SaveFilterModal = ({ show, handleClose, handleSave, filters }) => {
        const [filterName, setFilterName] = useState('');
        const [nameExists, setNameExists] = useState(false);

        const handleSubmit = (e) => {
            e.preventDefault();

            if (FilterNames.some(filter => filterName === filter.name)) {
                setNameExists(true);
            }
            else {
                setSelectedfiltername({name: filterName});
                handleSave(filterName, filters);
                setFilterName(filterName);
                setNameExists(false);
            }
        };

        return (
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Save Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="save-filter-body">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="filterName">
                            <Form.Label>Filter Name</Form.Label>
                            <Form.Control type="text" value={filterName} onChange={(e) => setFilterName(e.target.value)} />
                            {nameExists && 
                                <Form.Label class="mt-2" style={{color: 'red'}} >Filter name already exists</Form.Label>
                            }
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={handleSubmit}>
                        Save & Apply
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };
    

    const handleCloseModal = async (selectedRows) => {

        try {
            if (selectedRows !== undefined && selectedRows && selectedRows.length > 0) {
                setLoading(true);
                const ids = selectedRows.map(row => row.id).join(',');
                const response = await fetch(`${apiUrl}/screeningsummary/ScreeningDataWithStaffid`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `bearer ${jwt}`,
                    },
                    body: JSON.stringify(ids),
                });
                const res = await response.json();
                if (res.message != null) {

                    window.alert(res.message);
                    setLoading(false);
                }
                else {


                    setScreeningData(res.data);
                    setLoading(false);
                }

            }
        } catch (error) {
            console.error('Error during API call:', error);

        }
        setshowModalstaffsearch(false);

    };
    const handeladvanceopen = () => {
        setshowModalstaffsearch(true);
    }
    const handleFilterrefresh = (e) => {
        handleFilterSubmit(e);
    }

    return (
        <>
            {Bulkupdatepopupmodal && staffdata && (< Bulkupdatepopup show={Bulkupdatepopupmodal} onHide={() => { setBulkupdatepopupmodal(false); setErrorMessage(null); }} />)}
            <LoadingSpinner loading={loading} />
            <div className="ScreeningTable d-flex">
                <Table columns={filterColumns(columns)} data={screeningData} updateMyData={updateMyData}
                    skipPageReset={skipPageReset} Topfilter={Topfilter} Companyfilter={Companyfilter} Savedfilter={Savedfilter} Filtervalues={filtersTorender} onGlobalFilterChange={handleGlobalFilterChange} Externalvalue={handelSearchfilter} exportingacess={exportaccess} handeladvanceserch={handeladvanceopen} handelonupdate={handleFilterrefresh} combinedfilter={Forfiltertags} handelbulkupdate={Bulkupdatestaff} accessGroups={accessGroups} />
            </div>

            <div className="advance-search d-flex position-relative">


                <StaffSearch showModal={showModalstaffsearch} handleClose={handleCloseModal} />
            </div>
            {isLoadingcompleted && PrescreenmodalShow && (
                <MydModalWithGrid
                    data={PopupPreScreeningdata}
                    show={PrescreenmodalShow}
                    onHide={() => {
                        setPrescreenmodalShow(false);
                    }} />)}
            {

                isLoadingcompleted && ScreeningavailablitymodalShow && (
                    <PreScreeningavailablityWithGrid
                        data={PopupScreeningAvailbalitydata}
                        show={ScreeningavailablitymodalShow}
                        onHide={() => {
                            setScreeningavailablitymodalShow(false);

                        }} />

                )
            }


        </>
    );

}

export default Screeningtable;

